import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './DetailsToInvoiceForm.scss';

const DetailsToInvoiceInputField = (props) => {
  const isInvalid = (props.meta.error && !props.meta.active && props.meta.touched);
  return (
    <div className={styles.inputWrapper}>
      <input
        type="text"
        placeholder={props.placeholder}
        className={cx(
          'form-control',
          {
            not_valid: isInvalid,
            touched: props.meta.touched
          }
        )}
        {...props.input}
        id={props.input.name}
      />
      <span className={`icon icon-${props.iconName}`} />
      {isInvalid && (<span className={styles.errorMsg}>{props.errorMsg}</span>)}
    </div>
  );
};

DetailsToInvoiceInputField.propTypes = {
  iconName: PropTypes.string,
  placeholder: PropTypes.string,
  errorMsg: PropTypes.string,
  meta: PropTypes.object,
  input: PropTypes.object
};

export default DetailsToInvoiceInputField;
